const config = {
  cesiumAccessToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIwMWI3N2I2Zi1mMTBlLTRkZTUtODlkMS01OTQ4ZGY4MDI3MTUiLCJpZCI6MTg5NDMsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1OTM3NDI0NDN9.EhWpOzH8XDwyCWTnyp3yq0SM4WGY1ToVZi3HUMbBr3Q'
};

export default config;
